import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';

export const trackPendingChangesEvent = createTrackerForCategory('Pending Changes');
